(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["iconic-image-comparison-first"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('iconic-image-comparison-first')) {
    class IconicImageComparisonFirst extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.initImageComparisonFirst();
      }
      initImageComparisonFirst() {
        const container = this.querySelector('.iconic-container-compare');

        this.querySelector('.iconic-slider-input').addEventListener('input', (e) => {
          container.style.setProperty('--position', `${e.target.value}%`);
        });
      }
    }
    customElements.define('iconic-image-comparison-first', IconicImageComparisonFirst);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
